<template>
  <input v-bind="$attrs" v-on="inputListeners" class="input" :value="value" />
</template>

<script>
export default {
  name: 'Input',
  props: {
    value: [String, Number],
    validators: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    validate(event) {
      const result = this.validators
        .map((x) => {
          const value = event.target.value;
          return x(value);
        })
        .every((x) => Boolean(x));
      if (result) {
        return true;
      }
      event.target.value = this.value;
      return false;
    },
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        change: (event) => {
          if (this.validate(event)) this.$emit('change', event.target.value);
        },
        input: async (event) => {
          if (this.validate(event)) this.$emit('change', event.target.value);
        },
      };
    },
  },
};
</script>

<style scoped>
.input {
  width: 100%;
  background-color: #fff;
  border: 1px solid #f7f7f7;
  font-size: 24px;
  height: 65px;
  padding: 16px 20px 0px 20px;
  appearance: none;
}
</style>
